import { useState } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

import { revokeGuestAccess } from "api";
import { ReactComponent as CircleCross } from "assets/images/icons/CircleCross.svg";

function ManageAccessUserItem({ company, shipmentId, setErrorMessage, setResponseMessage, getListOfGuestUsers }) {
  const [hoveredUser, setHoveredUser] = useState(null);
  const [isRevoking, setIsRevoking] = useState(false);

  const handleMouseEnter = (user) => {
    setHoveredUser(user);
  };

  const handleMouseLeave = () => {
    setHoveredUser(null);
  };

  const onRevokeGuestAccess = (inviteId) => {
    setIsRevoking(true);
    setErrorMessage("");
    revokeGuestAccess(shipmentId, inviteId)
      .then((res) => {
        if (res.status === 204) {
          setResponseMessage("Guest access revoked");
          getListOfGuestUsers();
        }
      })
      .catch((err) => setErrorMessage(err.message))
      .finally(() => {
        setIsRevoking(false);
      });
  };

  return (
    <div className="user-item" style={{ marginBottom: "10px" }}>
      <div className="font-weight-bold">{company.company}</div>
      <div className="user-list">
        {company.users.map((user) => (
          <div
            className="d-flex align-items-center"
            style={{ height: "20px" }}
            key={user.user_full_name}
            onMouseEnter={() => handleMouseEnter(user)}
            onMouseLeave={handleMouseLeave}
          >
            {hoveredUser === user && isRevoking ? (
              <FontAwesomeIcon icon={faCircleNotch} className="text-secondary" spin />
            ) : (
              <div className="d-flex">
                <div className="text-xs font-regular text-primary">{user.user_full_name}</div>
                {user.email && user.email !== user.user_full_name && (
                  <div className="ml-xxs text-xs font-regular text-tertiary">({user.email})</div>
                )}
                {!user.is_non_revocable && (
                  <span
                    className="pl-2 cursor-pointer"
                    style={{ visibility: hoveredUser === user ? "visible" : "hidden" }}
                    onClick={() => onRevokeGuestAccess(user.id)}
                  >
                    <CircleCross />
                  </span>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

ManageAccessUserItem.propTypes = {
  company: PropTypes.shape({
    company: PropTypes.string.isRequired,
    users: PropTypes.arrayOf(
      PropTypes.shape({
        user_full_name: PropTypes.string.isRequired,
      }),
    ).isRequired,
  }).isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  shipmentId: PropTypes.string.isRequired,
  setResponseMessage: PropTypes.func.isRequired,
  getListOfGuestUsers: PropTypes.func.isRequired,
};

export default ManageAccessUserItem;
